<app-alert-container></app-alert-container>

<app-global-loading></app-global-loading>

<app-sidebar *ngIf="sidebarCollapsed() !== null" [sidebarCollapsed]="sidebarCollapsed()"
  (toggleSidebar)="toggleSidebar()" [ngClass]="[
    sidebarCollapsed() ? 'w-[80px]' : 'w-[250px]',
    'transition-all duration-300 ease-in-out h-screen fixed top-0 left-0 bg-slate-900 text-white overflow-y-auto overflow-x-hidden'
  ]" class="z-40" [ngStyle]="{
    'z-index': '900',
    'background-color': '#0f172a'
  }" />

<app-auth></app-auth>

<!-- Botão flutuante de colapsar sidebar -->
<button (click)="toggleSidebar()" aria-label="Alternar sidebar"
  class="fixed top-7 z-[9999] bg-primary hover:bg-[#e65d00] text-white rounded-full w-6 h-6 flex items-center justify-center shadow-md transition-all duration-300"
  [ngStyle]="{
    left: sidebarCollapsed() ? '68px' : '244px'
  }" style="cursor: pointer;">
  <mat-icon class="text-white text-base leading-none">
    {{ sidebarCollapsed() ? 'chevron_right' : 'chevron_left' }}
  </mat-icon>
</button>

<app-header class="fixed top-0 h-20 z-50 shadow-sm bg-white transition-all duration-300" [ngStyle]="{
    'margin-left': sidebarCollapsed() ? '80px' : '257px',
    'width': sidebarCollapsed() ? 'calc(100% - 80px)' : 'calc(100% - 257px)', 'z-index': '100'
  }" />

<!-- Conteúdo principal -->
<main class="fixed bg-gray-50 overflow-y-auto w-screen transition-all duration-300 px-6 py-6" [ngStyle]="{
    'padding-left': sidebarCollapsed() ? '110px' : '290px',
    'margin-top': '80px',
    'height': 'calc(100vh - 80px)',
    'z-index': '10'
  }">

  <router-outlet></router-outlet>
</main>

<!-- Componente de avaliação -->
<app-rating-feedback></app-rating-feedback>